import { subdomain, isTestMode, isSubplatformHost } from '/app/composables/platform';
import { defineAppRouteMiddleware } from '/app/utils/app';
import { redirectTo } from '/app/utils/navigation';
import { config } from '/app/config';

/**
 * Middleware to redirect routes with platformSlug to bignerve.com
 * when accessed from a subplatform
 */
export default defineAppRouteMiddleware((to) => {
    // Check if the route has a platformSlug
    const isUserPlatform = !!to.params.platformSlug && to.params.platformSlug !== 'platform';

    const isSubplatform = isSubplatformHost(subdomain);

    // Base URL for BigNerve
    const appUrl = new URL(config.app.baseURL);

    // Redirect conditions:
    // 1. We are on a subplatform
    // 2. The route has platformSlug
    // 3. It's a user platform
    // 4. We are not in test mode
    // 5. The current hostname is not BigNerve's
    if (isSubplatform &&
        isUserPlatform &&
        !isTestMode &&
        location.hostname !== appUrl.hostname) {

        // Redirect to bignerve.com keeping the full path
        const redirectUrl = `${appUrl.origin}${to.fullPath}`;
        console.log(`[platform-redirect] Redirecting to: ${redirectUrl}`);

        return redirectTo(redirectUrl);
    }
})